/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EvidenceMicrosoftClarityTrackingService {
  constructor() {}

  trackSetLocationEventMSClarity(evidenceUid: string): void {
    if ((window as any).clarity) {
      (window as any).clarity('set', 'location changed', `${evidenceUid}`);
      (window as any).clarity('event', 'location changed');
    }
  }
}
